import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b3cdb65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-banner__left" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<span class=\"app-banner__image\" data-v-b3cdb65a><img src=\"/assets/logos/android-chrome-192x192.png\" alt=\"\" data-v-b3cdb65a></span><span class=\"app-banner__info\" data-v-b3cdb65a><span class=\"app-banner__title\" data-v-b3cdb65a>FeelYou – Mental health</span><span class=\"app-banner__category\" data-v-b3cdb65a>Health and Fitness</span><span class=\"app-banner__store\" data-v-b3cdb65a>Get it on Google Play</span></span>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "app-banner__view-button" }, "View", -1))

import { IonIcon } from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBanner',
  emits: ['hide', 'close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

function install() {
  window.open('https://play.google.com/store/apps/details?id=io.feelyou.app', '_blank');
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "app-banner",
    onClick: install
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "app-banner__close-button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('hide')), ["stop"]))
      }, [
        _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
      ]),
      _hoisted_2
    ]),
    _hoisted_4
  ]))
}
}

})